<template>
	<!--<tr v-bind:class="{ 'alpha-danger'  :  !element.active}"> -->
	<tr v-bind:class="{ 'alpha-danger'  :  element.disabled}">
		<td class="text-center font-size-sm text-muted line-height-1">{{element.id}}</td>
        <td>
			<i class="icon-user-tie text-danger" title="Super Admin" v-if="isSuperAdmin"></i>
			<i class="icon-user text-danger" title="Admin" v-if="isAdmin"></i>
			<i class="icon-lock" v-if="element.private"></i>
			<a href="javascript:void(0)" @click="view">
            {{element.firstName}} {{element.lastName}}
			</a>
		</td>
		<td>
			<a href="javascript:void(0)" @click="view">
				{{element.email}}
			</a>
		</td>
		<td>
			{{element.joinedAt | momentTZ}}
		</td>
		<td>
			{{element.totalRecipesCount}} Total<br/>
			<!--{{element.recipesCount}} Published<br/> -->
			{{element.draftRecipesCount}} Draft{{element.draftRecipesCount === 1 ? '' : 's'}}<br />
			{{element.privateRecipesCount}} Private<br />
		</td>
		<td>
			{{element.friendsCount}}
		</td>
		<td>
			<i class="fas fa-key m-1" v-if="element.loginPassword" style="font-size: 14px;" title="Password Sign In"></i>
			<i class="fab fa-google m-1" v-if="element.loginGoogle" style="font-size: 14px;" title="Google Sign In"></i>
			<i class="fab fa-facebook m-1" v-if="element.loginFacebook"  style="font-size: 16px;" title="Facebook Sign In"></i>
			<i class="fab fa-apple m-1" v-if="element.loginApple"  style="font-size: 18px;" title="Apple Sign In"></i><br />
			{{element.lastActiveAt | momentTZ}}
			<div v-if="!element.active" class="text-danger">Registration incomplete</div>
		</td>
		<td>
			{{element.disabled ? 'Inactive' : 'Active'}}
		</td>

		<td class="text-center">
			<div class="list-icons">
				<div class="dropdown">
					<a href="#" class="list-icons-item dropdown-toggle caret-0" data-toggle="dropdown" aria-expanded="false"><i class="icon-more2 rotate-90"></i></a>
					<div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
						<a href="javascript:void(0)" class="dropdown-item" @click="view"><i class="icon-file-eye"></i> View</a>

						<a v-if="notLoggedInUser && !isSuperAdmin && !element.disabled" href="javascript:void(0)" @click="deactivate" class="dropdown-item"><span class="badge badge-mark  mr-3 border-danger" ></span> Suspend </a>
						<a v-if="notLoggedInUser && element.disabled" href="javascript:void(0)" @click="activate" class="dropdown-item"><span class="badge badge-mark  mr-3 border-blue" ></span> Un-suspend </a>

						<a v-if="notLoggedInUser && loggedUserIsSuperAdmin && !isSuperAdmin && !isAdmin" href="javascript:void(0)" @click="makeAdmin" class="dropdown-item"><i class="icon-user"></i> Add Admin Role</a>
						<a v-if="notLoggedInUser && loggedUserIsSuperAdmin && isAdmin" href="javascript:void(0)" @click="removeAdmin" class="dropdown-item"><i class="icon-user text-danger"></i> Remove Admin Role</a>

						<div class="dropdown-divider" v-if="notLoggedInUser && !isSuperAdmin"></div>
						<a href="javascript:void(0)" v-if="notLoggedInUser && !isSuperAdmin" class="dropdown-item" @click="deleteElementConfirmation" ><i class="icon-cross2 text-danger"></i> Delete </a>
					</div>
				</div>
			</div>
		</td>
	</tr>
</template>

<script>

export default {
	components : {

	},
    props: {
		position: {
			type: Number,
			required: false
		},
        element: {
            type: Object,
            required : true
        },
        filters: {
            type: Object,
            required : true
        },
        loading: {
            type: Object,
            default : {
                status : false
            }
        }
    },
    computed: {
    	hasCategories : function(){
    		return this.element.categories.length > 0
		},
		categoriesList : function(){
    		return _.map(this.element.categories, function(cat){ return cat.title}).join(', ')
    	},
    	categoriesCount : function(){
    		return this.element.categories.length
		},
		thumbnailUrl : function(){
    		return  this.element.thumbnail
    	},
		isSuperAdmin: function() {
    		return this.element.role === 'ROLE_SUPER_ADMIN'
		},
		isAdmin: function() {
			return this.element.role === 'ROLE_ADMIN'
		},
		notLoggedInUser: function() {
    		return this.loggedUser.id !== this.element.id;
		}
    },
    methods : {
    	activate : function () {
			self = this;
			Swal.fire({
				title: "Are you sure?",
				text: "User will be able to sign in again!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, un-suspend user!",
				cancelButtonText: "No, cancel!",
			}).then((isConfirm) => {
				if (isConfirm.dismiss !== 'cancel') {
					this.saveStatus({
						userId : this.element.id,
						disabled : false
					});
				}
			});
    	},
    	deactivate : function () {
			self = this;
			Swal.fire({
				title: "Are you sure?",
				text: "User will NOT be able to sign in again!",
				icon: "warning",
				input: 'textarea',
				inputPlaceholder: 'Type the reason here...',
				showCancelButton: true,
				confirmButtonText: "Yes, suspend user!",
				cancelButtonText: "No, cancel!",
			}).then((isConfirm) => {
				if (isConfirm.dismiss !== 'cancel') {
					this.saveStatus({
						userId : this.element.id,
						disabled : true,
						reason: isConfirm.value
					});
				}
			});

    	},
		makeAdmin : function () {
			Swal.fire({
				title: "Are you sure?",
				text: "User will gain admin privileges!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, make admin!",
				cancelButtonText: "No, cancel!",
			}).then((isConfirm) => {
				if (isConfirm.dismiss !== 'cancel') {
					this.saveAdmin({
						userId : this.element.id,
						admin : true
					});
				}
			});
		},
		removeAdmin : function () {
			Swal.fire({
				title: "Are you sure?",
				text: "User will lose admin privileges!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, remove admin role!",
				cancelButtonText: "No, cancel!",
			}).then((isConfirm) => {
				if (isConfirm.dismiss !== 'cancel') {
					this.saveAdmin({
						userId : this.element.id,
						admin : false
					});
				}
			});
		},
    	saveStatus : function(data){
            this.loading.status = true;
            this.$store.dispatch('users/status', data )
            .then((response) => {
                this.loading.status = false;
                this.$emit('element:updated');
				Swal.fire({
					title: "Success!",
					text: data.disabled ? "User login disabled." : "User login enabled.",
					icon: "success",
					timer: 2000
				});
            })
            .catch( error => {
                this.loading.status = false;
                this.errors = error.status.errors;
				Swal.fire({
					title: "Changing the user status failed.",
					text: "",
					icon: "error",
					timer: 2000
				});
            });
        },
		saveAdmin : function(data){
			this.loading.status = true;
			this.$store.dispatch('users/admin', data )
					.then((response) => {
						this.loading.status = false;
						this.$emit('element:updated');
						Swal.fire({
							title: "Success!",
							text: data.admin ? "Admin role added to user." : "Admin role removed from user.",
							icon: "success",
							timer: 2000
						});
					})
					.catch( error => {
						this.loading.status = false;
						this.errors = error.status.errors;

						Swal.fire({
							title: "Changing the admin role failed.",
							text: "",
							icon: "error",
							timer: 2000
						});
					});
		},
        view: function (){
            this.$router.push({ name : 'users-edit' , params: { id: this.element.id  }, query: { backToPage: this.$route.params.page } });
        },

        deleteElementConfirmation : function(){
            self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "All user data will be deleted!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel!",
            }).then((isConfirm) => {
                if (isConfirm.dismiss !== 'cancel') {
                    self.deleteElement();
                }
            });
        },

        deleteElement : function(){
        	this.loading.status = true;
            this.$store.dispatch('users/delete', {id : this.element.id} )
            .then((response) => {
            	this.loading.status = false;
                this.$emit('element:updated');
				Swal.fire({
                    title: "Deleted!",
                    text: "User has been deleted.",
					icon: "success",
					timer: 2000
                });

            })
            .catch( response => {
                this.loading.status = false;
				Swal.fire({
					title: "User deletion failed.",
                    text: "",
                    icon: "error",
					timer: 2000
                });
                //this.errors = error.status.errors
            });
        }

    }
};
</script>